import { queryOptions } from '@tanstack/react-query'
import { paymentAccountApi } from './api'
import { PaymentAccountFilters } from './models'
import { Pagination } from '@thinknimble/tn-models'

export const paymentAccountQueries = {
  all: () => ['payment-accounts'],
  retrieve: (id: string) => {
    return queryOptions({
      queryKey: [...paymentAccountQueries.all(), id],
      queryFn: () => paymentAccountApi.retrieve(id),
      enabled: Boolean(id),
    })
  },
  list: ({
    filters,
    pagination,
    paginationCallback,
  }: {
    filters?: Partial<PaymentAccountFilters>
    pagination?: Pagination
    paginationCallback?: (pagination: Pagination) => void
  } = {}) => {
    return queryOptions({
      queryKey: [...paymentAccountQueries.all(), { filters, pagination }],
      queryFn: async () => {
        const res = await paymentAccountApi.list({
          filters,
          pagination,
        })
        const serverPagination = new Pagination({ ...res, totalCount: res.count })
        paginationCallback?.(serverPagination)
        return res
      },
      enabled: true,
    })
  },
}
